import { createStructuredSelector } from "reselect";
import {
    AMBULANCE_MAINTENANCE_PLATES,
    AMBULANCE_MAINTENANCE_PLATES_SUCCESS,
    AMBULANCE_MAINTENANCE_PLATES_ERROR,
    AMBULANCE_MAINTENANCE_CHASIS,
    AMBULANCE_MAINTENANCE_CHASIS_SUCCESS,
    AMBULANCE_MAINTENANCE_CHASIS_ERROR,
    AMBULANCE_MAINTENANCE_CODE_IGSS,
    AMBULANCE_MAINTENANCE_CODE_IGSS_SUCCESS,
    AMBULANCE_MAINTENANCE_CODE_IGSS_ERROR,
    AMBULANCE_MAINTENANCE_LIST,
    AMBULANCE_MAINTENANCE_LIST_SUCCESS,
    AMBULANCE_MAINTENANCE_LIST_ERROR,
    AMBULANCE_MAINTENANCE_LIST_SEARCH_CHANGE,
    AMBULANCE_MAINTENANCE_LIST_SEARCH_SET,
    AMBULANCE_MAINTENANCE_LIST_PAGE_SET,
    AMBULANCE_MAINTENANCE_DETAIL,
    AMBULANCE_MAINTENANCE_DETAIL_SUCCESS,
    AMBULANCE_MAINTENANCE_DETAIL_ERROR,
    AMBULANCE_MAINTENANCE_VIEW_MODAL_SET,
    AMBULANCE_MAINTENANCE_UPDATE_MODAL_SET,
    AMBULANCE_MAINTENANCE_UPDATE_CHANGE_SET,
    AMBULANCE_MAINTENANCE_UPDATE,
    AMBULANCE_MAINTENANCE_UPDATE_SUCCESS,
    AMBULANCE_MAINTENANCE_UPDATE_ERROR,
} from "../../actions";

export const NAME = 'ambulanceMaintenance';

export const AmbulanceMaintenanceSelector = createStructuredSelector({
    ambulanceMaintenance: (state) => state.ambulanceMaintenance,
});

export const AmbulanceMaintenancePlates = (data) => ({ type: AMBULANCE_MAINTENANCE_PLATES, payload: data });
export const AmbulanceMaintenancePlatesSuccess = (data) => ({ type: AMBULANCE_MAINTENANCE_PLATES_SUCCESS, payload: data });
export const AmbulanceMaintenancePlatesError = (error) => ({ type: AMBULANCE_MAINTENANCE_PLATES_ERROR, payload: error });

export const AmbulanceMaintenanceChasis = (data) => ({ type: AMBULANCE_MAINTENANCE_CHASIS, payload: data });
export const AmbulanceMaintenanceChasisSuccess = (data) => ({ type: AMBULANCE_MAINTENANCE_CHASIS_SUCCESS, payload: data });
export const AmbulanceMaintenanceChasisError = (error) => ({ type: AMBULANCE_MAINTENANCE_CHASIS_ERROR, payload: error });

export const AmbulanceMaintenanceCodeIgss = (data) => ({ type: AMBULANCE_MAINTENANCE_CODE_IGSS, payload: data });
export const AmbulanceMaintenanceCodeIgssSuccess = (data) => ({ type: AMBULANCE_MAINTENANCE_CODE_IGSS_SUCCESS, payload: data });
export const AmbulanceMaintenanceCodeIgssError = (error) => ({ type: AMBULANCE_MAINTENANCE_CODE_IGSS_ERROR, payload: error });

export const AmbulanceMaintenanceList = (page, num_page, filters) => ({ type: AMBULANCE_MAINTENANCE_LIST, payload: { page, num_page, filters } });
export const AmbulanceMaintenanceListSuccess = (data) => ({ type: AMBULANCE_MAINTENANCE_LIST_SUCCESS, payload: data });
export const AmbulanceMaintenanceListError = (error) => ({ type: AMBULANCE_MAINTENANCE_LIST_ERROR, payload: error });
export const AmbulanceMaintenanceListSearchChange = (data) => ({ type: AMBULANCE_MAINTENANCE_LIST_SEARCH_CHANGE, payload: data });
export const AmbulanceMaintenanceListSearchSet = (data) => ({ type: AMBULANCE_MAINTENANCE_LIST_SEARCH_SET, payload: data });
export const AmbulanceMaintenanceListPageSet = (data) => ({ type: AMBULANCE_MAINTENANCE_LIST_PAGE_SET, payload: data });

export const AmbulanceMaintenanceDetail = (data) => ({ type: AMBULANCE_MAINTENANCE_DETAIL, payload: data });
export const AmbulanceMaintenanceDetailSuccess = (data) => ({ type: AMBULANCE_MAINTENANCE_DETAIL_SUCCESS, payload: data });
export const AmbulanceMaintenanceDetailError = (error) => ({ type: AMBULANCE_MAINTENANCE_DETAIL_ERROR, payload: error });

export const AmbulanceMaintenanceViewModalSet = (data) => ({ type: AMBULANCE_MAINTENANCE_VIEW_MODAL_SET, payload: data });

export const AmbulanceMaintenanceUpdateModalSet = (data) => ({ type: AMBULANCE_MAINTENANCE_UPDATE_MODAL_SET, payload: data });
export const AmbulanceMaintenanceUpdateChangeSet = (data) => ({ type: AMBULANCE_MAINTENANCE_UPDATE_CHANGE_SET, payload: data });
export const AmbulanceMaintenanceUpdate = (data, id_ambulance) => ({ type: AMBULANCE_MAINTENANCE_UPDATE, payload: { data, id_ambulance } });
export const AmbulanceMaintenanceUpdateSuccess = (data) => ({ type: AMBULANCE_MAINTENANCE_UPDATE_SUCCESS, payload: data });
export const AmbulanceMaintenanceUpdateError = (error) => ({ type: AMBULANCE_MAINTENANCE_UPDATE_ERROR, payload: error });
